import { createHubBatchMode } from "./hubBatchSelection";

export const MATERIALS_HUB_BATCH_ACTIONS = Object.freeze({
  IMPORT_CSV: "import-csv",
  DELETE_SELECTED: "delete-selected",
});

export const MATERIALS_HUB_BATCH_MODE = createHubBatchMode({
  enabled: true,
  actions: [
    {
      id: MATERIALS_HUB_BATCH_ACTIONS.IMPORT_CSV,
      label: "Import CSV",
      requiresSelection: false,
      alwaysVisible: true,
    },
    {
      id: MATERIALS_HUB_BATCH_ACTIONS.DELETE_SELECTED,
      label: (count) => `Delete Selected (${count})`,
      destructive: true,
      alwaysVisible: true,
    },
  ],
});

/**
 * @returns {import("./hubBatchSelection").HubBatchModeDefinition|null}
 */
export function getMaterialsHubBatchMode() {
  return MATERIALS_HUB_BATCH_MODE.enabled ? MATERIALS_HUB_BATCH_MODE : null;
}
